import {
  confirmPasswordReset,
  sendPasswordResetEmail,
  verifyPasswordResetCode,
} from 'firebase/auth';
import { getFirebaseAuth } from './firebaseAuth';
import { getPortalConfig, PORTALS, portalFromPath } from './portals';

export const RESET_PROBLEM = {
  EXPIRED_LINK: 'expiredLink',
  INVALID_LINK: 'invalidLink',
  WEAK_PASSWORD: 'weakPassword',
  UNKNOWN: 'unknown',
};

const PROBLEM_BY_ERROR_CODE = {
  'auth/expired-action-code': RESET_PROBLEM.EXPIRED_LINK,
  'auth/invalid-action-code': RESET_PROBLEM.INVALID_LINK,
  'auth/user-disabled': RESET_PROBLEM.INVALID_LINK,
  'auth/user-not-found': RESET_PROBLEM.INVALID_LINK,
  'auth/weak-password': RESET_PROBLEM.WEAK_PASSWORD,
};

export function getResetProblem(error) {
  return PROBLEM_BY_ERROR_CODE[error?.code] || RESET_PROBLEM.UNKNOWN;
}

// Asks Firebase to email a reset link. The link's `continueUrl` is the
// Portal's login page, which is how the reset page knows which Portal it is
// serving. An address nobody registered looks like any other, so the person
// asking learns nothing about who has an account.
export function sendPasswordReset(portal, email) {
  const loginUrl = `${window.location.origin}${
    getPortalConfig(portal).loginPath
  }`;

  return sendPasswordResetEmail(getFirebaseAuth(), email, {
    url: loginUrl,
  }).catch((error) => {
    if (error?.code !== 'auth/user-not-found') {
      throw error;
    }
  });
}

// Resolves with the address the link was sent to, or rejects if the link is
// expired, used or otherwise not valid.
export function verifyResetCode(oobCode) {
  return verifyPasswordResetCode(getFirebaseAuth(), oobCode);
}

export function confirmReset(oobCode, newPassword) {
  return confirmPasswordReset(getFirebaseAuth(), oobCode, newPassword);
}

export function portalFromContinueUrl(continueUrl) {
  try {
    return portalFromPath(new URL(continueUrl).pathname);
  } catch (error) {
    return PORTALS.ADMIN;
  }
}
